import Vue from 'vue'
import Router from 'vue-router'
import authService from '@/services/authentication'

import Register from '@/components/register'
import Confirm from '@/components/confirm'
import ForgotPassword from '@/components/forgot_password'
import ResetPassword from '@/components/reset_password'
import Login from '@/components/login'

import ProfileShow from '@/components/profile/show'
import JargonContact from '@/components/jargon/contact'
import JargonPolicy from '@/components/jargon/policy'
import JargonPricing from '@/components/jargon/pricing'
import PreferenceShow from '@/components/preference/show'
import PasswordShow from '@/components/password/show'

import ProjectIndex from '@/components/project/index'
import ProjectShow from '@/components/project/show'
import ProjectBacklog from '@/components/project/backlog'

import BoardShow from '@/components/board/show'

import TicketShow from '@/components/ticket/show'

import WatchIndex from '@/components/watch/index'

import EmailIndex from '@/components/email/index'
import EmailShow from '@/components/email/show'

import ShareShow from '@/components/share/show'

import PurchaseIndex from '@/components/purchase/index'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/',
  routes: [
    { path: '/',
      redirect: '/projects'
    },

    {
      path: '/register',
      component: Register
    },

    {
      path: '/confirm-registration',
      component: Confirm,
      props: (route) => ({
        token: route.query.token,
        askPassword: false
      })
    },

    {
      path: '/confirm-invitation',
      component: Confirm,
      props: (route) => ({
        token: route.query.token,
        askPassword: true
      })
    },

    {
      path: '/forgot-password',
      component: ForgotPassword
    },

    {
      path: '/reset-password',
      component: ResetPassword,
      props: (route) => ({
        token: route.query.token
      })
    },

    {
      path: '/login',
      component: Login,
      beforeEnter (to, from, next) {
        // make sure we are logged out if we are seeing the login screen
        authService.logout()
        next()
      }
    },

    {
      path: '/logout',
      beforeEnter (to, from, next) {
        authService.logout()
        next('/login')
      }
    },

    {
      path: '/profile',
      component: ProfileShow,
      props: true,
      beforeEnter: requireAuth
    },

    {
      path: '/preference',
      component: PreferenceShow,
      props: true,
      beforeEnter: requireAuth
    },

    {
      path: '/jargon/contact',
      component: JargonContact
    },

    {
      path: '/jargon/policy',
      component: JargonPolicy
    },

    {
      path: '/jargon/pricing',
      component: JargonPricing
    },

    {
      path: '/password',
      component: PasswordShow,
      props: true,
      beforeEnter: requireAuth
    },

    {
      path: '/projects',
      component: ProjectIndex,
      beforeEnter (to, from, next) {
        requireAuth(to, from, next)
      }
    },

    {
      path: '/projects/:id',
      component: ProjectShow,
      props: true,
      beforeEnter: requireAuth
    },

    {
      path: '/projects/:id/backlog',
      component: ProjectBacklog,
      props: true,
      beforeEnter: requireAuth
    },

    {
      path: '/boards/:id',
      component: BoardShow,
      props: true,
      beforeEnter: requireAuth
    },

    // should not realy use this, we wan to always use sequential Ids
    // there is a usecase though, like if we load split tickets and only have Ids
    {
      path: '/tickets/:id',
      component: TicketShow,
      props: (route) => ({
        id: route.params.id,
        boardId: route.query.boardId,
        projectId: route.query.projectId
      }),
      beforeEnter: requireAuth
    },

    {
      path: '/boards/:boardId/tickets/:sequentialId',
      component: TicketShow,
      props: true,
      beforeEnter: requireAuth
    },

    {
      path: '/projects/:projectId/tickets/:sequentialId',
      component: TicketShow,
      props: true,
      beforeEnter: requireAuth
    },

    {
      path: '/watches',
      component: WatchIndex,
      beforeEnter (to, from, next) {
        requireAuth(to, from, next)
      }
    },

    // NOTE: Im unsure if I should group emails under the projects folder, or just in the urls
    // ie, should the component be ProjectEmailIndex?
    {
      path: '/projects/:projectId/emails',
      component: EmailIndex,
      props: true,
      beforeEnter (to, from, next) {
        requireAuth(to, from, next)
      }
    },

    {
      path: '/projects/:projectId/emails/:id',
      component: EmailShow,
      props: true,
      beforeEnter (to, from, next) {
        requireAuth(to, from, next)
      }
    },

    {
      path: '/projects/:projectId/purchases',
      component: PurchaseIndex,
      props: true,
      beforeEnter (to, from, next) {
        requireAuth(to, from, next)
      }
    },

    {
      path: '/shares/:token',
      component: ShareShow,
      props: true,
      name: 'shares',
      beforeEnter (to, from, next) {
        // do NOT require authentication
        next()
      }
    }
  ]
})

function requireAuth (to, from, next) {
  if (!authService.loggedIn()) {
    next({
      path: '/login'
    })
  } else {
    next()
  }
}



// WEBPACK FOOTER //
// ./src/router/index.js